import React from "react";
import Navbar from "./Navbar"; // Adjust the path as needed

const MinimalLayout = ({ children }) => {
  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900 text-xs">
      {/* No Sidebar - Full width for content */}
      <div className="w-full flex flex-col">
        <Navbar />
        <main className="bg-white flex-1 p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MinimalLayout;
